/**
 * MobileCard — renders children as a card row on mobile.
 * Usage: wrap each "table row" in this when xs view is active.
 */
import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';

export function MobileCard({ children, onClick, sx = {} }) {
  return (
    <Card
      onClick={onClick}
      sx={{
        mb: 1.5, cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick ? { boxShadow: 4 } : {},
        ...sx,
      }}
    >
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        {children}
      </CardContent>
    </Card>
  );
}

export function MobileRow({ label, value, bold, mono }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
      <Typography variant="caption" color="text.secondary" sx={{ minWidth: 110 }}>{label}</Typography>
      <Typography
        variant="body2"
        fontWeight={bold ? 700 : 400}
        sx={{ fontFamily: mono ? 'monospace' : 'inherit', textAlign: 'right' }}
      >
        {value}
      </Typography>
    </Box>
  );
}
